import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FlattenFolders_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', appearance: { __typename?: 'AssetAggregateAppearance', flattenFolders: boolean } };

export type FlattenFolders_Collection_Fragment = { __typename?: 'Collection', appearance: { __typename?: 'AssetAggregateAppearance', flattenFolders: boolean } };

export type FlattenFolders_CollectionShare_Fragment = { __typename?: 'CollectionShare', appearance: { __typename?: 'AssetAggregateAppearance', flattenFolders: boolean } };

export type FlattenFoldersFragment = FlattenFolders_AdHocAssetsShare_Fragment | FlattenFolders_Collection_Fragment | FlattenFolders_CollectionShare_Fragment;

export const FlattenFolders = /*#__PURE__*/ gql`
    fragment FlattenFolders on AssetAggregate {
  appearance {
    flattenFolders
  }
}
    ` as unknown as DocumentNode<FlattenFoldersFragment, unknown>;

        

        
export const useFlattenFoldersFragment = (
  input: string | Omit<UseFragmentOptions<FlattenFoldersFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetAggregate' } };
    return input;
  })();

  return useFragment<FlattenFoldersFragment>({
    fragment: FlattenFolders,
    fragmentName: 'FlattenFolders',
    ...options,
  });
};
  
        